// Groupomania color palette
const colors = {
  primary: "#072049",
  secondary: "#ffd7d7",
  secondaryDark: "#ce4651",
  gray: "#6c757d",
};

export default colors;
